import * as React from 'react'
import { Box, Button } from '@mui/material'
import {
  accumulateNodeUpdates,
  getNodeReplacementsForExisting,
  sortImageUrls,
  TreeImageContext,
} from './utility'
import { ConfirmCommitButton } from 'shared/ui'
import { INode } from 'shared/types/tree'
import { openTab } from '../Helpers'
import { getNodeUrl } from '../utility/TreeNavigation'
import { updateAll } from '../tree/nodeUpdates/utility'
import { NodeBasedUpdates } from '../tree/nodeUpdates/types'

export function ExternalImageReplace({
  allImageUrls,
  existingImages,
}: {
  allImageUrls: string[]
  existingImages: { [key: string]: string }
}) {
  const [missingImages, setMissingImages] = React.useState<string[]>([])
  const [canFix, setCanFix] = React.useState<string[]>([])
  const [allExternal, setAllExternal] = React.useState<string[]>([])
  const [updates, setUpdates] = React.useState<NodeBasedUpdates[]>([])
  const [nodesToUpdate, setNodesToUpdate] = React.useState<INode[]>()

  React.useEffect(() => {
    const { canFix, missing, external } = sortImageUrls(
      allImageUrls,
      existingImages,
    )
    setMissingImages(missing)
    setCanFix(canFix)
    setAllExternal(external)
  }, [allImageUrls, existingImages])

  const { imageImportScript, idMap, tree } = React.useContext(TreeImageContext)

  React.useEffect(() => {
    const updates = accumulateNodeUpdates(
      getNodeReplacementsForExisting({
        tree,
        externalUrls: canFix,
        existingByName: existingImages,
      }),
    )
    setUpdates(updates)
    const nodes = updates.reduce<INode[]>((acc, { node }) => {
      node && acc.push(node)
      return acc
    }, [])
    setNodesToUpdate(nodes)
  }, [canFix, existingImages, tree])

  function fixAll() {
    return updateAll(...updates)
  }

  if (!nodesToUpdate) return <Box>Please Wait...</Box>

  return (
    <Box>
      <Box>{`${missingImages.length} External Images; ${canFix.length} Can Be Fixed`}</Box>
      <Button onClick={() => imageImportScript(...missingImages)}>
        Import Missing ({missingImages.length})
      </Button>
      <Button onClick={() => imageImportScript(...allExternal)}>
        Reimport All ({allExternal.length})
      </Button>
      <ConfirmCommitButton onClick={fixAll}>
        <>Update All</>
      </ConfirmCommitButton>
      <Box padding={'10px'}>
        <Box>{`${nodesToUpdate.length} Nodes To Update`}</Box>
        {updates.map((updateData, index) => {
          const { node } = updateData
          return (
            <Box key={node?.id ?? index}>
              <Button onClick={() => node && openTab(getNodeUrl(node, idMap))}>
                {node?.title ?? 'No Node Cant Navigate'}
              </Button>
              {`${updates.length} Image Urls To Replace`}
              <ConfirmCommitButton onClick={() => updateAll(updateData)}>
                Fix
              </ConfirmCommitButton>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
